import BaseViewController from "./base-view-controller";
import extractFieldValues from "../utils/extract-field-values";

class RecoverUsernameViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    switch (name) {
      case "recoverUsernameButton":
        const initialValues = extractFieldValues(
          this.screen,
          this.appData.values,
          this.appData.data
        );
        this.appData.nextScreen({
          data: this.appData.data,
          showDialog: this.dialog.showDialog,
          screenIndex: this.appData.screenIndex,
          formState: initialValues,
          action
        });
        break;
      case "redirectToLogin":
        window.location.href = "/signin";
        break;
      default:
        super.handleButtonClick(name, text, action);
        break;
    }
  }
}

export default RecoverUsernameViewController;
